/*
XOL-552 (round 2): which subscriber row is THIS RTB's Backhaul Customer record.

Step 3 of a Customer RTB reads `GET backhaul/subscribers/site/{siteId}/org/{orgId}`,
which is keyed by site and org only — it has no ORDER BY and knows nothing about
the RTB, so `data[0]` was whatever MySQL returned first. The row does carry the
raw `action_id` (the RTB that created it), so the SPA picks by that.

Tiers, in order — the first tier with a row wins:
  1. rows linked to this RTB (`action_id` equals `actionId`);
  2. otherwise the telco's UNLINKED legacy rows (`action_id` null). Saving one
     from this RTB stamps `action_id` (BackhaulCustomer.onSave), which links it
     from then on. No authoritative link exists for legacy rows, so this is not
     a migration — it is what the step already showed, minus edit mode.
Rows linked to a DIFFERENT RTB are never returned.

Within a tier: a live (not Terminated) row first — a preference, not a filter,
so an all-Terminated tier still returns one row; then the newest
`updated_at || created_at` (ISO-8601 UTC strings, so they sort as text; a row
with neither sorts last); then the highest id.

Pure and non-mutating. Babel 6: no optional chaining, no nullish coalescing.
------------------------------------------------------------------------ */

function stamp (row) {
  return String(row.updated_at || row.created_at || '')
}

function isTerminated (row) {
  return row.status === 'Terminated'
}

// > 0 when `a` should be picked over `b`.
function better (a, b) {
  var aLive = isTerminated(a) ? 0 : 1
  var bLive = isTerminated(b) ? 0 : 1
  if (aLive !== bLive) return aLive - bLive

  var aStamp = stamp(a)
  var bStamp = stamp(b)
  if (aStamp !== bStamp) return aStamp > bStamp ? 1 : -1

  return Number(a.id) - Number(b.id)
}

function best (rows) {
  var top = null

  for (var i = 0; i < rows.length; i++) {
    if (top === null || better(rows[i], top) > 0) top = rows[i]
  }

  return top
}

/**
 * The record for `actionId` among `rows`, or null (a new record).
 * `rows` is the site+org list after fetchDataRawURL unwraps `.data`.
 */
export function pickRequestRecord (rows, actionId) {
  if (!Array.isArray(rows) || rows.length === 0) return null

  var linked = []
  var unlinked = []

  for (var i = 0; i < rows.length; i++) {
    var row = rows[i]
    if (!row) continue

    if (row.action_id === null || row.action_id === undefined) {
      unlinked.push(row)
    } else if (actionId !== null && actionId !== undefined && Number(row.action_id) === Number(actionId)) {
      linked.push(row)
    }
  }

  if (linked.length) return best(linked)

  return best(unlinked)
}
